// Which of your genres a book can have, by its literary genre (Kristi, Oct 28: strict).
//   Poetry   only the poetry genres (Lyric, Narrative, Dramatic)
//   Fiction  only fiction genres; Nonfiction only nonfiction genres
//   A genre that belongs to no literary genre yet (Education, for now) shows for Fiction and
//   Nonfiction, never for Poetry. A book with no literary genre yet sees every genre.
// Hidden genres (Young Adult and Children's Books, since 0035: audience carries them) never show.
// A genre already on a book always stays shown, so nothing disappears.

export type Literary = 'fiction' | 'nonfiction' | 'poetry' | 'drama';

export interface GenreOption {
  name: string;
  short: string | null;
  /** The literary genre it belongs to (from its starter genre), or null. */
  literary: Literary | null;
  hidden?: boolean;
}

export function genreFits(genre: Literary | null, book: Literary | null): boolean {
  if (!book) return true;
  if (!genre) return book === 'fiction' || book === 'nonfiction';
  return genre === book;
}

/** The genre names to offer for a book: fitting ones in your order, plus any it already has. */
export function genreChoices(all: GenreOption[], book: Literary | null, has: string[] = []): string[] {
  const shown = all.filter((g) => !g.hidden && genreFits(g.literary, book)).map((g) => g.name);
  return [...shown, ...has.filter((h) => !shown.includes(h))];
}

export const LITERARY_CHOICES: { key: Literary; name: string }[] = [
  { key: 'fiction', name: 'Fiction' },
  { key: 'nonfiction', name: 'Nonfiction' },
  { key: 'poetry', name: 'Poetry' },
];

export type Audience = 'adult' | 'young_adult' | 'children';
export const AUDIENCE_CHOICES: { key: Audience; name: string }[] = [
  { key: 'adult', name: 'Adult' },
  { key: 'young_adult', name: 'Young adult' },
  { key: 'children', name: 'Children' },
];
